module.exports = __webpack_public_path__ + "static/media/word-frequency-app.9bcd95e4.png";